import { render, staticRenderFns } from "./ProgressHeader.vue?vue&type=template&id=3dd45675&scoped=true&"
import script from "./ProgressHeader.vue?vue&type=script&lang=js&"
export * from "./ProgressHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProgressHeader.vue?vue&type=style&index=0&id=3dd45675&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd45675",
  null
  
)

export default component.exports